<div class="coupled-system">
  <ng-container *ngIf="draggable">
    <oes-notify
      [iconName]="'fa-info'"
      [message]="'generation-design.*c-subheader' | translate"
      [type]="'hint'">
    </oes-notify>
  </ng-container>
  <table class="system-schema">
    <tbody>
      <tr id="second-row" class="dc-system-schema-row">
        <td></td>
        <td></td>
        <td>
          <p class="system-bus dc-coupled dc-bus">
            <span>
              <img src="../../../../assets/images/generation-design/icn-dc-bus.svg">
            </span>
          </p>
        </td>
        <td></td>
        <td></td>
        <td>
          <p class="system-bus dc-coupled ac-bus">
            <span>
              <img src="../../../../assets/images/generation-design/icn-ac-bus.svg">
            </span>
          </p>
        </td>
      </tr>
      <tr id="third-row" class="dc-system-schema-row">
        <td class="dc-system-schema-component"
            data-testid2="gen-design-panels">
          <oes-generation-system-component
            data-testid="gen-design-type-label"
            [draggable]="componentStatus[componentType.PANELS].available"
            [inUse]="componentStatus[componentType.PANELS].inUse"
            [componentType]="componentType.PANELS"
            [capacity]="capacities[componentType.PANELS]">
          </oes-generation-system-component>
        </td>
        <td></td>
        <td class="vertical-line"></td>
        <td></td>
        <td></td>
        <td class="vertical-line arrow-cell">
          <img src="../../../../assets/images/generation-design/icn-arrow-double.svg">
        </td>
        <td class="dc-system-schema-component">
          <oes-generation-system-component
            data-testid="gen-design-type-label"
            [draggable]="componentStatus[componentType.GRID].available"
            [inUse]="componentStatus[componentType.GRID].inUse"
            [componentType]="componentType.GRID"
            [extra]="extra.grid">
          </oes-generation-system-component>
        </td>
      </tr>
      <tr id="fourth-row" class="dc-system-schema-row">
        <td style="max-width: 100%" class="d-flex justify-content-center">
          <img src="../../../../assets/images/generation-design/icn-arrow-down.svg">
        </td>
        <td></td>
        <td class="vertical-line"></td>
        <td></td>
        <td></td>
        <td class="vertical-line"></td>
      </tr>
      <tr id="fifth-row" class="dc-system-schema-row">
        <td class="dc-system-schema-component">
          <oes-generation-system-component
            data-testid="gen-design-type-label"
            [inUse]="componentStatus[componentType.CHARGE_CONTROLLER].inUse"
            [draggable]="componentStatus[componentType.CHARGE_CONTROLLER].available"
            [componentType]="componentType.CHARGE_CONTROLLER"
            [capacity]="capacities[componentType.CHARGE_CONTROLLER]">
          </oes-generation-system-component>
        </td>
        <td class="arrow-cell">
          <img src="../../../../assets/images/generation-design/icn-arrow-right.svg">
        </td>
        <td class="vertical-line"></td>
        <td></td>
        <td></td>
        <td class="vertical-line arrow-cell">
          <img src="../../../../assets/images/generation-design/icn-arrow-right.svg">
        </td>
        <td>
          <oes-generation-system-component
            data-testid="gen-design-type-label"
            [draggable]="false"
            [componentType]="componentType.LOAD"
            [extra]="extra.load">
          </oes-generation-system-component>
        </td>
      </tr>
      <tr id="sixth-row" class="dc-system-schema-row spacer-row">
        <td></td>
        <td></td>
        <td class="vertical-line"></td>
        <td></td>
        <td></td>
        <td class="vertical-line"></td>
        <td></td>
        <td></td>
      </tr>
      <tr id="seventh-row" class="dc-system-schema-row">
        <td class="dc-system-schema-component">
          <oes-generation-system-component
            data-testid="gen-design-type-label"
            [draggable]="componentStatus[componentType.STORAGE].available"
            [inUse]="componentStatus[componentType.STORAGE].inUse"
            [componentType]="componentType.STORAGE"
            [capacity]="capacities[componentType.STORAGE]">
          </oes-generation-system-component>
        </td>
        <td class="arrow-cell">
          <img src="../../../../assets/images/generation-design/icn-arrow-double.svg">
        </td>
        <td class="vertical-line arrow-cell">
          <img src="../../../../assets/images/generation-design/icn-arrow-double.svg">
        </td>
        <td class="dc-system-schema-component">
          <oes-generation-system-component
            data-testid="gen-design-type-label"
            [draggable]="componentStatus[componentType.SYSTEM_INVERTER].available"
            [inUse]="componentStatus[componentType.SYSTEM_INVERTER].inUse"
            [componentType]="componentType.SYSTEM_INVERTER"
            [capacity]="capacities[componentType.SYSTEM_INVERTER]">
          </oes-generation-system-component>
        </td>
        <td class="arrow-cell">
          <img src="../../../../assets/images/generation-design/icn-arrow-double.svg">
        </td>
        <td class="vertical-line arrow-cell">
          <img src="../../../../assets/images/generation-design/icn-arrow-left.svg">
        </td>
        <td class="dc-system-schema-component">
          <oes-generation-system-component
            data-testid="gen-design-type-label"
            [draggable]="componentStatus[componentType.GENERATOR].available"
            [inUse]="componentStatus[componentType.GENERATOR].inUse"
            [componentType]="componentType.GENERATOR"
            [capacity]="capacities[componentType.GENERATOR]">
          </oes-generation-system-component>
        </td>
      </tr>
    </tbody>
  </table>
</div>
